import claimsIcon from "../../../Assets/Images/sidebar-claims-icon.svg";
import contactUsIcon from "../../../Assets/Images/sidebar-contact-us-icon.svg";
import moreInfoIcon from "../../../Assets/Images/sidebar-more-info-icon.svg";
import refundIcon from "../../../Assets/Images/sidebar-refund-icon.svg";
import thingsNotCoveredIcon from "../../../Assets/Images/sidebar-things-not-covered-icon.svg";

const items = [
  {
    url: process.env.REACT_APP_CUSTOMER_SERVICE_LINK,
    icon: claimsIcon,
    title: "Claims",
  },
  {
    url: process.env.REACT_APP_EXCLUDED_OBJECTS_ACTIVITIES_LINK,
    icon: thingsNotCoveredIcon,
    title: "Things not covered",
  },
  {
    url: process.env.REACT_APP_REFUNDS_AND_CANCELLATIONS_LINK,
    icon: refundIcon,
    title: "Refunds",
  },
  {
    url: process.env.REACT_APP_CUSTOMER_SERVICE_LINK,
    icon: contactUsIcon,
    title: "Contact us",
  },
  {
    url: process.env.REACT_APP_FAQS_LINK,
    icon: moreInfoIcon,
    title: "FAQs",
  },
];

const SidebarItems = ({ referralParams }: { referralParams?: string }) => (
  <div className="sidebar__items d-flex flex-column">
    {items.map((item, index) => (
      <a
        key={index}
        className="sidebar__item d-flex flex-column align-items-center justify-content-center"
        href={`${item.url}${referralParams}`}
        target="_blank"
        rel="noreferrer"
      >
        <img className="sidebar__item-icon" src={item.icon} alt={item.title} />
        <span>{item.title}</span>
      </a>
    ))}
  </div>
);

export default SidebarItems;
